<template>
<content-div>
  <div class="contArea">
    <!-- tabType1 -->
    <div class="tabType2">
      <ul class="col2">
        <li v-for="(item, index) in terms" :key="index"
          :class="[($route.params.type == item) ? 'on' : '']">
          <router-link :to="`/termInfo/${item}`"><span>{{termTitle(item)}}</span></router-link>
        </li>
      </ul>
    </div>

    <div class="tabCont ">
      <h2 class="hidden">{{termTitle(termType)}}</h2><!-- //선택된 탭명으로 변경 필요 -->
    
      <section class="inPageTerms">
        <h1 class="conTit1 jqTermsName"></h1>
        <div class="jaTermsCont">
          <TermContent :termType="termType"></TermContent>
          <!-- <div v-html="term" style="padding:10px;"></div> -->
        </div>
      </section>

      <!-- <div class="termsCon">
        <dl>
          <dt class="conTit1 jqTermsName"></dt>
          <dd class="extendBox">
            <div class="con jaTermsCont"></div>
            <button type="button" class="btnExtend">펼쳐보기</button>
          </dd>
        </dl>
      </div> -->
    </div>


  </div>
</content-div>
</template>


<script>

import ConstTerms from "../../helpers/ConstTerms";
import TermContent from "../../components/Term/TermContent.vue";

export default {
  
  components: {
    TermContent,
  },

  data() {
    return {
      terms: [
        ConstTerms.SERVICE_AGREEMENT
        //,ConstTerms.PERSONAL_INFO
        ,ConstTerms.INSURANCE
      ]
    }
  },

  computed:{
    termType() { return this.$route.params.type },
    termsList() {return this.filterTerms()}
  },

  methods: {
    filterTerms() {
      const pkgs = this.$store.state.pkgs;

			for(const key in pkgs) {
				if(pkgs[key].group === 'POWER TRAIN') {
					this.terms.push(ConstTerms.INSURANCE);
					break;
				}
			}
			return this.terms;
    },
    termTitle(termType) { return ConstTerms.getTermsTitle()[termType]; }
  },
}
</script>

<style scoped>

</style>